import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faDownload } from '@fortawesome/free-solid-svg-icons';
import DemoBlock from './Flipbook';
import { Sparkles } from "lucide-react";
import omslag from "../assets/images/omslag.jpg";
import Audio from "../assets/Saga.mp3";
// 👇 Generera alla demosidor automatiskt
const totalPages = 12;
const demoPages = Array.from({ length: totalPages }, (_, i) =>
  `/assets/pdf/${i + 1}.jpg`
);

const demoBook = {
  id: "demo-book",
  name: "Saga och Vänskapens Hemliga Stigar",
  summary: "I den magiska parken i Uppsala upptäcker den nyfikna Saga och hennes vänner en gammal skattkarta som leder dem på ett äventyr fyllt av mysterier, skratt och ovärderliga vänskapsminnen.",
  omslag_image_url: omslag,
  audio_url: Audio,
  image_urls: ["/images/demo-page1.jpg", "/images/demo-page2.jpg", "/images/demo-page3.jpg"],
};

const DemoBook = () => {
  const [isDemoBookOpen, setDemoBookOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const [showFlipbook, setShowFlipbook] = useState(false); // 💡 Nytt state

  return (
    <section className="w-full bg-warmWhite shadow rounded-lg p-6">
    <h2 className="text-3xl md:text-4xl text-center text-black font-bold mb-6">
      Lyssna på vår egna bok
    </h2>
  
    <div className="text-center px-4">
      <span className="inline-flex items-center px-4 py-2 rounded-full text-magic-800 font-quicksand mb-4 text-sm md:text-base">
        Så här kommer dina böcker att se ut! När du skapar en bok blir den tillgänglig för nedladdning direkt i din personliga kontrollpanel.
      </span>
    </div>
  
    <div className="center-container mt-8">
      <div
        className={`border bg-white rounded-lg p-4 ${showFlipbook ? 'w-full' : 'responsive-card'}`}
        style={{
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.06)",
          minHeight: showFlipbook ? '880px' : '600px',
          display: 'flex',
          flexDirection: 'column',
          maxWidth: showFlipbook ? '1200px' : undefined,
          margin: '0 auto',
        }}
      >
        <div className="flex-grow">
          {!showFlipbook ? (
            <>
              <div className="mb-4">
                <h2 className="text-xl text-center font-semibold">{demoBook.name}</h2>
                <p className="text-center text-gray-500 text-sm italic mt-1">
                  Klicka på bilden för att öppna boken
                </p>
              </div>
  
              {demoBook.omslag_image_url && (
                <div className="mb-4">
                  <img
                    src={demoBook.omslag_image_url}
                    alt="Omslagsbild"
                    className="w-full h-auto object-cover rounded border border-gray-300 shadow-sm cursor-pointer"
                    style={{ boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.4)" }}
                    onClick={() => setShowFlipbook(true)}
                  />
                </div>
              )}
  
              <div className="mb-4">
                <h3 className="font-semibold text-gray-800">Sammanfattning:</h3>
                <p className="text-gray-600">{demoBook.summary}</p>
              </div>
            </>
          ) : (
            <>
              <div className="flex justify-end mb-4">
                <button
                  onClick={() => setShowFlipbook(false)}
                  className="text-white px-3 py-1 rounded shadow-sm hover:opacity-90 transition"
                  style={{
                    background: "linear-gradient(90deg,rgb(51, 101, 126), #347fa4, rgb(51, 101, 126))",
                  }}
                >
                  Stäng bok
                </button>
              </div>
              <DemoBlock pages={demoPages} />
            </>
          )}
        </div>
  
        {/* 🔊 Ljudspelare placeras alltid längst ner i kortet */}
        {demoBook.audio_url && (
          <div className="mt-6 w-full">
            <audio controls className="w-full">
              <source src={demoBook.audio_url} type="audio/mpeg" />
              Din webbläsare stödjer inte ljuduppspelning.
            </audio>
          </div>
        )}
      </div>
    </div>
  
    {/* ❌ Modal för förstorad bild tas bort helt */}
  </section>
  
  );
};

export default DemoBook;
